document.addEventListener("DOMContentLoaded", () => {
    const section = document.querySelector("#img_scroll_toBig");
    if (!section) return;

    const wrap = section.querySelector(".scroll-wrap");
    const imgBox = section.querySelector(".img");

    const container = section.querySelector("#img_scroll_toBig .container");

    let ticking = false;

    function update() {
        const rect = wrap.getBoundingClientRect();
        const windowH = window.innerHeight;

        // 计算滚动进度
        let progress = (windowH - rect.top) / (rect.height) - 0.3;
        progress = Math.max(0, Math.min(1, progress));

        // 缓动（更丝滑）
        // const easeProgress = 1 - Math.pow(1 - progress, 3);

        const easeProgress = Math.pow(progress, 0.4);

        // scale范围（你可以调）
        const scale = 1 + easeProgress * 1.5; // 最大放大到 2.5

        // 位移（让它更像“向屏幕扑”）
        const translateY = easeProgress * -50;

        imgBox.style.transform = `
            scale(${scale}) 
            translateY(${translateY}px)
        `;

        // console.log(easeProgress, 'easeProgress');

        container.style.maxWidth = 120 + easeProgress * 100 + 'rem';

        // 🔥 当接近全屏时锁滚动（可选增强）
        if (progress > 0 && progress < 1) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        ticking = false;
    }

    function onScroll() {
        if (!ticking) {
            requestAnimationFrame(update);
            ticking = true;
        }
    }

    window.addEventListener("scroll", onScroll);
});